import { Component, OnInit } from '@angular/core';
import { DashboardService } from 'src/app/services/dashboard.service';
import { LanguageService } from 'src/app/services/language.service';
import { MessagesService } from 'src/app/services/messages.service';
import { AlertMessageService } from 'src/app/services/alert-message.service';

@Component({
  selector: 'app-dashboard-operator',
  templateUrl: './dashboard-operator.component.html',
  styleUrls: ['./dashboard-operator.component.scss']
})
export class DashboardOperatorComponent implements OnInit {

  dashboard:any={};
  messages:Array<any>;
  openId=-1;
  constructor(private dashboardService:DashboardService,
    private languageService:LanguageService,
    private messageService:MessagesService,
    private alertMessageService:AlertMessageService) {
      this.dashboardService.getWarehouseDashboard().subscribe((result)=>{
        if(result['status'])
          this.dashboard=result;
      });     
    }

  ngOnInit() {
    this.getMessage();
  }

  getMessage(){
    let language = this.languageService.getCurrentLanguage();
    this.messageService.getMessage().subscribe((result)=>{
      this.messages=result['messages'];   
      console.log(this.messages) 
    }, error => {
      const messageCode = 'CE';
      this.alertMessageService.showErrorMessage(language, messageCode);
    })
  }

  openMessage(message,i){
    console.log(message)
    this.openId=i;
    let data = {
      message_id:message.id
    }
    this.messageService.readMessage(data).subscribe((result)=>{
      console.log(result);
      this.getMessage();
    });
  }

  showMessage(i){
    if(this.openId==i)
      this.openId=-1;
    else
      this.openId=i;
  }

}
